/* eslint-disable no-useless-catch */
import axios from "axios";

module.exports.getTeamMembersForCompany = async (company_id) => {
  let teamMembers;
  try {
    teamMembers = await axios.get(
      "/api/v2/companies/" + company_id + "/team"
    );
  } catch (err) {
    throw err;
  }
  return teamMembers.data;
};
module.exports.addTeamMemberToCompany = async (company_id, team_member) => {
  let addTeamMember;
  try {
    addTeamMember = await axios.post(
      "/api/v2/companies/" + company_id + "/team",
      team_member
    );
  } catch (err) {
    throw err;
  }
  return addTeamMember.data;
};
module.exports.patchTeamMember = async (company_id, team_member_id, team_member) => {
  let patchTeamMember;
  try {
    patchTeamMember = await axios.patch(
      "/api/v2/companies/" + company_id + "/team/" + team_member_id,
      team_member
    );
  } catch (err) {
    throw err;
  }
  return patchTeamMember.data;
};
module.exports.deleteTeamMember = async (company_id, team_member_id) => {
  let deleteTeamMember;
  try {
    deleteTeamMember = await axios.delete(
      "/api/v2/companies/" + company_id + "/team/" + team_member_id
    );
  } catch (err) {
    throw err;
  }
  return deleteTeamMember.data;
};
